export const skins = [
    {
        id: 'default',
        name: 'Aether Fighter',
        color: '#00d9ff',
        shape: 'cube',
        price: 0,
        owned: true
    },
    {
        id: 'triangle',
        name: 'Crimson Dart',
        color: '#ff0066',
        shape: 'triangle',
        price: 10
    },
    {
        id: 'circle',
        name: 'Verdant Orb',
        color: '#00ff88',
        shape: 'circle',
        price: 10
    },
    {
        id: 'star',
        name: 'Solar Star',
        color: '#ffd700',
        shape: 'star',
        price: 15
    },
    {
        id: 'neon',
        name: 'Neon Viper',
        color: '#ff00ff',
        shape: 'cube',
        price: 15
    },
    {
        id: 'fire',
        name: 'Ember Sphere',
        color: '#ff4400',
        shape: 'circle',
        price: 20
    },
    {
        id: 'ice',
        name: 'Frost Lance',
        color: '#00ffff',
        shape: 'triangle',
        price: 20
    },
    {
        id: 'gold',
        name: 'Gilded Nova',
        color: '#ffaa00',
        shape: 'star',
        price: 25
    }
];

export class SkinManager {
    constructor(iapManager = null) {
        this.iapManager = iapManager;
        this.ownedSkins = this.loadOwnedSkins();
        this.currentSkin = this.loadCurrentSkin();
    }

    async syncWithIAP() {
        if (!this.iapManager) return;

        try {
            // Get purchases from IAP (async)
            const iapPurchases = await this.iapManager.getPurchases();

            // Merge with owned skins
            if (Array.isArray(iapPurchases)) {
                iapPurchases.forEach(skinId => {
                    if (!this.ownedSkins.includes(skinId)) {
                        this.ownedSkins.push(skinId);
                    }
                });

                this.saveOwnedSkins();
            }
        } catch (error) {
            console.warn('Failed to sync with IAP:', error);
        }
    }

    loadOwnedSkins() {
        const saved = localStorage.getItem('ownedSkins');
        if (saved) {
            return JSON.parse(saved);
        }
        return ['default'];
    }

    loadCurrentSkin() {
        const saved = localStorage.getItem('currentSkin');
        if (saved) {
            const skin = skins.find(s => s.id === saved);
            if (skin && this.ownedSkins.includes(skin.id)) {
                return skin;
            }
        }
        return skins[0]; // Default skin
    }

    saveOwnedSkins() {
        localStorage.setItem('ownedSkins', JSON.stringify(this.ownedSkins));
    }

    saveCurrentSkin() {
        localStorage.setItem('currentSkin', this.currentSkin.id);
    }

    isSkinOwned(skinId) {
        return this.ownedSkins.includes(skinId);
    }

    purchaseSkin(skinId, onSuccess, onError) {
        const skin = skins.find(s => s.id === skinId);
        if (!skin) {
            if (onError) onError('Skin not found');
            return false;
        }

        if (this.isSkinOwned(skinId)) {
            if (onError) onError('Already owned');
            return false;
        }

        // In a real implementation, this would integrate with Telegram Stars
        // For now, we'll just add it
        this.ownedSkins.push(skinId);
        this.saveOwnedSkins();

        if (onSuccess) onSuccess();
        return true;
    }

    selectSkin(skinId) {
        if (!this.isSkinOwned(skinId)) {
            return false;
        }

        const skin = skins.find(s => s.id === skinId);
        if (skin) {
            this.currentSkin = skin;
            this.saveCurrentSkin();
            return true;
        }
        return false;
    }

    getCurrentSkin() {
        return this.currentSkin;
    }

    getAllSkins() {
        return skins.map(skin => ({
            ...skin,
            owned: this.isSkinOwned(skin.id),
            selected: skin.id === this.currentSkin.id
        }));
    }
}
